var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSortDefault = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#323232",
  d: "M8.62 15.5h6.76L12 18.88zM5 14l7 7 7-7zM15.38 8.5H8.62L12 5.12zM19 10l-7-7-7 7z"
})));
export { SvgSortDefault as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguNjIgMTUuNUgxNS4zOEwxMiAxOC44OEw4LjYyIDE1LjVaTTUgMTRMMTIgMjFMMTkgMTRINVoiIGZpbGw9IiMzMjMyMzIiLz4KPHBhdGggZD0iTTE1LjM4IDguNUw4LjYyIDguNUwxMiA1LjEyTDE1LjM4IDguNVpNMTkgMTBMMTIgM0w1IDEwTDE5IDEwWiIgZmlsbD0iIzMyMzIzMiIvPgo8L3N2Zz4K";